/** Loads motion's DOM features on demand for `LazyMotion`, so they stay out of the initial bundle. */
export const loadMotionFeatures = () => import('./layoutFeatures').then((module) => module.default);
